import { Injectable } from "@angular/core";
import { IQuotationWarning } from "libraries/service/resources/quotation-quotations/IQuotationsQuotation";
import { Observable } from "rxjs";
import { ApiResourceService } from "libraries/service/apiResource/apiResource.service";

@Injectable()
export class WarningsResourceService {
    constructor(
        private readonly apiResourceService: ApiResourceService,
    ) {}

    public patch(warningId: number, warningActivated: boolean): Observable<IQuotationWarning[]> {
        return this.apiResourceService.patchOne(
            this.apiResourceService.getApiUrl('quotation', 'warnings', warningId),
            { isActive: warningActivated }
        );
    }
}